import styled from 'styled-components';
import { InfoBanner } from 'ui/banner';
import { InputSearch } from 'ui/inputs';
import { NewTabLink } from 'ui/links';
import { PageHeader } from 'ui/pageHeader';
import { PAGE_HEADER_VARIANTS } from 'ui/pageHeader/constants';
import { colors, spacing } from 'ui/theme';
import { FullWidth } from 'ui/utility/fullWidth';
import { useSearchParamsContext } from '../contexts';

const StyledFullWidth = styled(FullWidth)`
  padding-right: ${spacing.layoutLRPadding};
  padding-bottom: ${spacing.double};
  padding-left: ${spacing.layoutLRPadding};
  background-color: ${colors.backgroundSecondary};
`;

export const HEADER_TEXT = {
  bannerText:
    'Link expiration redirects legacy links after a date of your choosing. Select the link behavior and effective date for each project.',
  learnMoreURL: 'https://academy.iterable.com/link-expiration-management',
  pageTitle: 'Link Expiration Management',
  searchInputId: 'linkExpirationSearchInput',
  searchPlaceholder: 'Search projects',
};

const { bannerText, learnMoreURL, pageTitle, searchInputId, searchPlaceholder } = HEADER_TEXT;

export const Header = () => {
  const { search, setSearch } = useSearchParamsContext();

  return (
    <>
      <PageHeader
        pageActions={
          <InputSearch
            id={searchInputId}
            onChange={setSearch}
            placeholder={searchPlaceholder}
            value={search}
          />
        }
        variant={PAGE_HEADER_VARIANTS.SECONDARY}
      >
        {pageTitle}
      </PageHeader>
      <StyledFullWidth>
        <InfoBanner
          BannerActions={
            <NewTabLink href={learnMoreURL} variant="inherit">
              Learn more
            </NewTabLink>
          }
        >
          <span>{bannerText}</span>
        </InfoBanner>
      </StyledFullWidth>
    </>
  );
};
